/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type Image, ImageSchema } from './image'
import { type VideoAssetFile, VideoAssetFileSchema } from './video'

/* TypeScript */
export type VideoContent = {
  image?: Image
  video?: {
    title: string
    description?: string
    file: VideoAssetFile
  }
  id: string
}

export type VideosBlockApiProps = {
  technicalName?: string
  subtitle?: string
  title?: string
  videos: VideoContent[]
  ctaLink?: CTALink
}

/* Schemas */
export const VideoContentSchema = z.object({
  image: ImageSchema.optional(),
  video: z
    .object({
      title: z.string(),
      description: z.string().optional(),
      file: VideoAssetFileSchema,
    })
    .optional(),
  id: z.string(),
})

export const VideosBlockApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  subtitle: z.string().optional(),
  title: z.string().optional(),
  videos: z.array(VideoContentSchema),
  ctaLink: CTALinkSchema.optional(),
})

/* Schemas validation */
type TestVideosBlockProps = ExpectTrue<
  Equal<VideosBlockApiProps, z.infer<typeof VideosBlockApiPropsSchema>>
>
